module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[29]516.c69e6e9.woff2";